module.exports = __webpack_public_path__ + "static/media/p2_img1.27610134.png";